module.exports = __webpack_public_path__ + "static/img/ningde.5e13db2.png";


//////////////////
// WEBPACK FOOTER
// ./static/mapPoint/mapPicture/fujian/ningde.png
// module id = YR0a
// module chunks = 6